export default (suburb: string, state: string, postcode: string): string =>
  `${suburb}-${state}-${postcode}`
    .replace('&', 'and')
    .replace(/[^a-z0-9]+/gi, '-')
    .toLowerCase();
